const COMPANY_INFO = {
  name: 'Ekol Tabela',
  address: 'Saraylar, 504. Sk. No:2',
  city: 'Merkezefendi/Denizli',
  phone: '(0258) 265 67 84',
  email: 'info@ekoltabela.com'
};

const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  return date.toLocaleDateString('tr-TR');
};

export const printDeliveryNote = (order) => {
  const today = new Date().toLocaleDateString('tr-TR');
  const deliveryNo = `TF-${order.id}-${Date.now().toString().slice(-6)}`;

  const html = `
<!DOCTYPE html>
<html lang="tr">
<head>
  <meta charset="UTF-8">
  <title>Teslimat Fişi #${order.id}</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body {
      font-family: 'Segoe UI', Tahoma, sans-serif;
      font-size: 14px;
      color: #333;
      padding: 20px;
      background: #f5f5f5;
    }
    .delivery-note {
      max-width: 800px;
      margin: 0 auto;
      background: white;
      padding: 40px;
      border-radius: 10px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    }
    .header {
      display: flex;
      justify-content: space-between;
      padding-bottom: 25px;
      border-bottom: 3px solid #4caf50;
      margin-bottom: 25px;
    }
    .company h1 {
      font-size: 26px;
      color: #4caf50;
      margin-bottom: 5px;
    }
    .company p { color: #666; font-size: 13px; line-height: 1.6; }
    .doc-info { text-align: right; }
    .doc-info h2 {
      font-size: 28px;
      color: #4caf50;
      margin-bottom: 10px;
    }
    .doc-info p { color: #666; font-size: 13px; }
    .doc-info strong { color: #333; }
    
    .customer-section {
      background: #f8f9fa;
      border-radius: 8px;
      padding: 25px;
      margin-bottom: 30px;
    }
    .customer-section h3 {
      font-size: 12px;
      text-transform: uppercase;
      color: #888;
      margin-bottom: 15px;
      letter-spacing: 1px;
    }
    .customer-info {
      display: flex;
      gap: 40px;
    }
    .customer-info div {
      flex: 1;
    }
    .customer-info p { line-height: 1.8; }
    .customer-info strong { color: #333; font-size: 18px; }
    
    .delivery-details {
      margin-bottom: 30px;
    }
    .delivery-details h3 {
      font-size: 16px;
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 2px solid #4caf50;
      color: #333;
    }
    
    .detail-table {
      width: 100%;
      border-collapse: collapse;
    }
    .detail-table th {
      background: #e8f5e9;
      padding: 15px;
      text-align: left;
      font-size: 12px;
      text-transform: uppercase;
      color: #2e7d32;
      border-bottom: 2px solid #4caf50;
    }
    .detail-table td {
      padding: 15px;
      border-bottom: 1px solid #e0e0e0;
      font-size: 15px;
    }
    .detail-table tr:last-child td {
      border-bottom: none;
    }
    
    .delivery-confirmation {
      background: linear-gradient(135deg, #e8f5e9, #c8e6c9);
      border-radius: 10px;
      padding: 30px;
      margin: 30px 0;
      text-align: center;
      border: 2px solid #4caf50;
    }
    .delivery-confirmation .checkmark {
      font-size: 60px;
      margin-bottom: 15px;
    }
    .delivery-confirmation h3 {
      font-size: 24px;
      color: #2e7d32;
      margin-bottom: 10px;
    }
    .delivery-confirmation p {
      color: #558b2f;
      font-size: 16px;
    }
    
    .signatures {
      display: flex;
      justify-content: space-between;
      margin-top: 50px;
      gap: 40px;
    }
    .signature-box {
      flex: 1;
      text-align: center;
    }
    .signature-box .label {
      font-size: 12px;
      text-transform: uppercase;
      color: #888;
      margin-bottom: 60px;
      letter-spacing: 1px;
    }
    .signature-box .line {
      border-top: 2px solid #333;
      padding-top: 10px;
      font-weight: 600;
    }
    
    .footer {
      text-align: center;
      padding-top: 25px;
      margin-top: 30px;
      border-top: 1px solid #eee;
      color: #888;
      font-size: 12px;
    }
    
    .no-print { margin-bottom: 20px; text-align: center; }
    .no-print button {
      padding: 12px 30px;
      font-size: 16px;
      cursor: pointer;
      border: none;
      border-radius: 8px;
      margin: 0 10px;
    }
    .btn-print {
      background: linear-gradient(135deg, #4caf50, #2e7d32);
      color: white;
    }
    .btn-close { background: #f0f0f0; color: #666; }
    
    @media print {
      body { background: white; padding: 0; }
      .delivery-note { box-shadow: none; padding: 20px; }
      .no-print { display: none; }
    }
  </style>
</head>
<body>
  <div class="no-print">
    <button class="btn-print" onclick="window.print()">🖨️ Yazdır</button>
    <button class="btn-close" onclick="window.close()">✕ Kapat</button>
  </div>
  
  <div class="delivery-note">
    <div class="header">
      <div class="company">
        <h1> ${COMPANY_INFO.name}</h1>
        <p>
          ${COMPANY_INFO.address}<br>
          ${COMPANY_INFO.city}<br>
          Tel: ${COMPANY_INFO.phone}<br>
          ${COMPANY_INFO.email}
        </p>
      </div>
      <div class="doc-info">
        <h2>TESLİMAT FİŞİ</h2>
        <p>
          <strong>Fiş No:</strong> ${deliveryNo}<br>
          <strong>Sipariş No:</strong> #${order.id}<br>
          <strong>Tarih:</strong> ${today}
        </p>
      </div>
    </div>
    
    <div class="customer-section">
      <h3>Teslim Alan</h3>
      <div class="customer-info">
        <div>
          <p><strong>${order.customer_name || '-'}</strong></p>
          ${order.customer_phone ? `<p>Tel: ${order.customer_phone}</p>` : ''}
        </div>
        <div>
          <p><strong>Sipariş Tarihi:</strong> ${formatDate(order.order_date)}</p>
          ${order.delivery_date ? `<p><strong>Teslim Tarihi:</strong> ${formatDate(order.delivery_date)}</p>` : ''}
        </div>
      </div>
    </div>
    
    <div class="delivery-details">
      <h3>📦 Teslim Edilen İş</h3>
      <table class="detail-table">
        <thead>
          <tr>
            <th style="width: 30%">İş Türü</th>
            <th>Açıklama</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>${order.job_type || 'Tabela İşi'}</strong></td>
            <td>${order.description || '-'}</td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="delivery-confirmation">
      <div class="checkmark"></div>
      <h3>TESLİMAT TAMAMLANDI</h3>
      <p>Yukarıda belirtilen iş eksiksiz olarak teslim edilmiştir.</p>
    </div>
    
    <div class="signatures">
      <div class="signature-box">
        <div class="label">Teslim Eden</div>
        <div class="line">${COMPANY_INFO.name}</div>
      </div>
      <div class="signature-box">
        <div class="label">Teslim Alan</div>
        <div class="line">${order.customer_name || '.........................'}</div>
      </div>
    </div>
    
    <div class="footer">
      <p>Bu belge ${COMPANY_INFO.name} tarafından düzenlenmiştir.</p>
      <p style="margin-top: 5px">Tarih: ${today}</p>
    </div>
  </div>
</body>
</html>
  `;

  
  const printWindow = window.open('', '_blank');
  printWindow.document.write(html);
  printWindow.document.close();
};


export const printInvoice = printDeliveryNote;

export default { printDeliveryNote, printInvoice };